"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M13.415 5H15v2.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5V5h1.585a1.5 1.5 0 0 1 2.83 0m-1.915.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M8 5v2.5A1.5 1.5 0 0 0 9.5 9h5A1.5 1.5 0 0 0 16 7.5V5h1.5A1.5 1.5 0 0 1 19 6.5v12a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 18.5v-12A1.5 1.5 0 0 1 6.5 5zm1 7.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5m1 3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5"
  })]
}), 'RegisterFilled');
